import PropTypes from 'prop-types';
import React from 'react';
import FindOntologyRelatedResourceDialog from '../application-core/FindOntologyRelatedResourceDialog';

class FindOntologyRelatedDataDualModePassthroughDialog extends React.Component {

    render() {

        return (
            <FindOntologyRelatedResourceDialog
                {...this.props}
                mode={{
                    linkedSearchType: [
                        "http://www.w3.org/2004/02/skos/core#Concept",
                        "https://grafsync.graphifi.com/schema/gs/Resource"],
                    searchType: [
                        "https://grafsync.graphifi.com/schema/gs/Resource",
                        "http://www.w3.org/2004/02/skos/core#Concept"
                    ],
                    searchIn: [
                        "http://www.w3.org/2004/02/skos/core#inScheme",
                        "https://grafsync.graphifi.com/schema/gs/inDataset"
                    ],
                    linkedSearchLabel: [
                        "http://www.w3.org/2004/02/skos/core#prefLabel",
                        "http://www.w3.org/2000/01/rdf-schema#label"
                    ],
                    searchLabel: [
                        "http://www.w3.org/2000/01/rdf-schema#label",
                        "http://www.w3.org/2004/02/skos/core#prefLabel"
                    ]
                }} />
        );
    }
}

FindOntologyRelatedDataDualModePassthroughDialog.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object
    ])
};

export default FindOntologyRelatedDataDualModePassthroughDialog;